export default __webpack_public_path__ + "static/media/distributor_banner.ea25a7dd.png";